/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import PaymentRepository from '../../repositories/Admin/Memberships/PaymentRepository';
import { createRestSlice } from '../../utils/RestSlice';

const paymentRestSlice = createRestSlice({
  resource: 'payment',
  repository: PaymentRepository,
  slices: ['createPayment', 'deletePayment'],
});

const initialState = {
  ...paymentRestSlice.initialState,
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    ...paymentRestSlice.reducers,
  },
});

export default paymentSlice.reducer;

export const paymentRestHooks = paymentRestSlice.hooks(paymentSlice, [
  'admin',
  'PaymentSlice',
]);
